import { useWinners } from "../contexts/winners-context";
import GallerySliderMobile from "../common/slider-mobile";
import { WinnersSectionProps } from "../types/common";
import { YearQuery } from "../common/filter";

export default function MobileView({ data }: { data: WinnersSectionProps }) {
  const { loadingMore, loading, setPageNo, winners, year, setYear } = useWinners();

  return (
    <div className="lg:hidden">
      <GallerySliderMobile
        yearQuery={YearQuery.WINNERS_YEAR}
        data={data}
        loading={loading}
        items={winners}
        setPageNo={setPageNo}
        loadingMore={loadingMore}
        hasMainFilter={false}
        year={year}
        setYear={setYear}
      />
    </div>
  );
}
